export enum ContractType {
  Full = 0,
  ZeroDevicePackage = 1 << 0
}
